import { render, staticRenderFns } from "./DialogConfitmDelete.vue?vue&type=template&id=497346b6"
import script from "./DialogConfitmDelete.vue?vue&type=script&lang=js"
export * from "./DialogConfitmDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports